// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__rKlMK","log":"ModalInventoryLogs_log__1ZCbm","date":"ModalInventoryLogs_date__2UB0V","userName":"ModalInventoryLogs_userName__3tHVZ"};